import Img from "./img";
const NotifyBell = () => {
	return (
		<div className="notify-bell">
			<Img className="dark-icon" src="/images/svg/bell.svg" />
			<Img className="light-icon" src="/images/svg/bell-light.svg" />
		</div>
	);
};
export default NotifyBell;
